import { ref, get, push, set } from 'firebase/database';
import { database, auth } from '../firebaseConfig';

export const PRICE_REDUCTION_TASK = 'Price Reduction: Send Reverse Prospecting + Lead Email';
export const parsePrice = (v) => { const n = parseFloat(String(v ?? '').replace(/[^0-9.]/g, '')); return Number.isFinite(n) && n > 0 ? n : null; };
const fmt = (n) => `$${Math.round(n).toLocaleString('en-US')}`;
const todayET = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });

// When a listing's price goes down, the Marketing Manager gets a manual task (due that day) to email agents who
// showed it and matching leads. Nothing is sent automatically. No task on increases, and no duplicate when an
// open one already exists for the same new price.
export const createPriceReductionTask = async (transactionId, oldPrice, newPrice, creatorUid) => {
  const oldN = parsePrice(oldPrice), newN = parsePrice(newPrice);
  if (!transactionId || oldN == null || newN == null || newN >= oldN) return { created: false };
  const tasksRef = ref(database, `transactions/${transactionId}/tasks`);
  const snap = await get(tasksRef);
  const open = snap.exists() ? Object.values(snap.val()) : [];
  if (open.some(t => t?.name === PRICE_REDUCTION_TASK && !['completed', 'na', 'skipped'].includes(t.status) && t.newPrice === newN)) return { created: false, duplicate: true };
  const record = {
    name: PRICE_REDUCTION_TASK, role: 'Marketing Manager', type: 'Task', appliesTo: 'Seller', mode: 'task',
    dueDate: todayET(), status: 'pending', completedBy: null, completedAt: null,
    createdBy: creatorUid || auth?.currentUser?.uid || null, createdAt: new Date().toISOString(),
    oldPrice: oldN, newPrice: newN,
    description: `Price reduced from ${fmt(oldN)} to ${fmt(newN)}. Email agents who showed it (ShowingTime) and matching leads about the price adjustment.`,
  };
  await set(push(tasksRef), record);
  return { created: true, record };
};
